import { render, staticRenderFns } from "./announce.vue?vue&type=template&id=4a922ab4"
import script from "./announce.vue?vue&type=script&lang=js"
export * from "./announce.vue?vue&type=script&lang=js"
import style0 from "./announce.vue?vue&type=style&index=0&id=4a922ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports